import { css } from "emotion";
import { H4, Label, P } from "../../../components/text/TextComponents";
import Image from "../../../components/Image";

const wrapper = css({
  width: 180,
  height: 240,
  position: "relative",
  padding: "181px 0 0 0",
  textAlign: "center",
  marginRight: 40,
  display: "inline-block",
  verticalAlign: "top",
  whiteSpace: "initial"
});

const imageStyle = css({
  position: "absolute",
  top: 27,
  left: 20,
  width: 140,
  height: 140,
  borderRadius: 4
});

const tapeStyle = css({
  position: "absolute",
  zIndex: 9,
  top: 0,
  left: "calc(50% - 12px)"
});

const TeamBlock = ({ member }) => {
  return (
    <div className={wrapper}>
      <Image
        imageURL={member.tape}
        styleSheet={tapeStyle}
        alt={`tape holding photo of team memeber up`}
      />
      <Image
        imageURL={member.mug}
        styleSheet={imageStyle}
        alt={`${member.name} photo`}
      />
      <H4 marginBottom={4} marginBottomMobile={4}>
        {member.name}
      </H4>
      <Label color="#5a626c" marginBottom={8} marginBottomMobile={8} semiBold>
        {member.title}
      </Label>
      {/* <P>{member.text}</P> */}
    </div>
  );
};

export default TeamBlock;
